<template>
  <div>
<!--    <Nav :msg="msg" :nav="nav"></Nav>-->
    <div class="back"><span @click="$router.back(-1)"> ＜返回 </span></div>
    <div class="detail">
      <one_page_module @insert="insert" :content="post.content" v-model="post.content"></one_page_module>
      <one_page_preview :content="post.content" v-model="post.content"></one_page_preview>
      <div class="create">
        <el-form label-width="80px" :model="post" ref="post" :rules="rules">
          <el-form-item label="标题" prop="title">
            <el-input v-model="post.title" placeholder="标题" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="封面" prop="cover">
<!--            <vue-upload v-model="post.cover" width="750" height="1050"></vue-upload>-->
            <el-upload style="width: 120px;height: 160px;border: 1px solid #DCDFE6;border-radius: 5px;"
                       class="upload-demo"
                       accept="image/*,.jpg,.png"
                       :show-file-list="false"
                       :on-change='changeUpload'>
              <i class="el-icon-upload" style="width: 120px;height: 160px;font-size: 60px;line-height: 160px;
    text-align: center;color: #409eff" v-if="!post.cover" ></i>
              <img :src="post.cover" style="width: 120px;height: 160px;border-radius: 5px;object-fit: contain" v-if="post.cover">
            </el-upload>
            <el-tag type="danger">宽高比例 3:4</el-tag>
          </el-form-item>
          <el-form-item label="分类" prop="phone">
            <el-select v-model="post.sort_id" clearable filterable placeholder="请选择分类" class="w-200">
              <el-option
                  v-for="it in sort_list"
                  :key="it.id"
                  :label="it.title"
                  :value="it.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="post.phone" placeholder="手机号" class="w-200"></el-input>
          </el-form-item>
          <el-form-item label="电子书">
            <el-select v-model="post.ebook_id" filterable class="w-200" clearable placeholder="搜索选择电子书">
              <el-option
                  v-for="it in ebook_list"
                  :key="it.id"
                  :label="it.title"
                  :value="it.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="禁止联系" prop="is_stop_contact">
            <el-switch  v-model="post.is_stop_contact"
                        active-value="1"
                        inactive-value="0"></el-switch>
          </el-form-item>
<!--          <el-form-item label="计费方式" prop="">-->
<!--            <template>-->
<!--              <el-radio v-model="post.look_type" label="1">次数</el-radio>-->
<!--              <el-radio v-model="post.look_type" label="2">时间</el-radio>-->
<!--            </template>-->
<!--          </el-form-item>-->
<!--          <template v-if="post.look_type==2">
            <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
          </template>-->
<!--          <el-form-item label="绑定微信" >
            <el-select v-model="post.uid" filterable remote clearable :remote-method="user_search" :loading="is_loading">
              <el-option v-for="(val,key) in list" :key="key" :value="val.id" :label="val.nickname">
                <div class="o-user">
                  <div class="o-avatarurl" :style="{ backgroundImage:'url('+val.avatarurl+')' }"></div>
                  <div class="o-nickname">{{val.nickname}}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>-->
          <img v-if="post.wxcode" :src="post.wxcode" alt="" style="margin: 10px 90px;width: 200px;height: 200px;">
          <img v-else :src="this.qrcode" alt="" style="margin: 10px 90px;width: 200px;height: 200px;">
          <el-form-item>
            <el-button type="primary" class="w-150" style="margin: 20px 40px" @click="submit">确认保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="cut">
      <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
        <div class="cropper-content">
          <div class="cropper" style="text-align:center">
            <vueCropper
                ref="cropper"
                :img="option.img"
                :outputSize="option.size"
                :outputType="option.outputType"
                :info="true"
                :full="option.full"
                :autoCropWidth="option.autoCropWidth"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :original="option.original"
                :autoCrop="option.autoCrop"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"
                :centerBox="option.centerBox"
                :infoTrue="option.infoTrue"
                :fixedBox="option.fixedBox"
            ></vueCropper>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import Nav from "@/components/nav";
// import FEdit from "@/components/form/f-edit";
// import FormUpload from "@/components/form/form-upload";
import one_page_module from "@/components/one_page/one_page_module";
import one_page_preview from "@/components/one_page/one_page_preview";
// import VueUpload from "@/components/upload/upload";
import VueCropper from 'vue-cropper'

export default {
  name: "detail",
  components:{
    // FEdit,Nav,
    one_page_module,one_page_preview,VueCropper
  },
  data(){
    // const is_phone = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error('请填写'))
    //   } else {
    //     // const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/
    //     // if (reg.test(value)) {
    //       callback()
    //     // } else {
    //     //   return callback(new Error('手机号有误'))
    //     // }
    //   }
    // }
    return{
      msg: 'one_page_detail',
      // nav:[
      //   {name:'＜返回',path:'one_page'},
      //   // {name:'添加 / 编辑单页',path:'one_page_detail'},
      // ],
      rules : {
        title : [{required:true, message : '请填写', trigger:'blur'}],
        cover : [{required:true, message : '请上传', trigger:'blur'}],
        // phone : [{required:true,validator:is_phone,trigger: 'blur'}],
      },
      post : {
        title : '',
        cover : '',
        phone:'',
        content:[],
        look_type:'1',
        is_stop_contact:'1',
        is_show:1
      },
      dir:[],
      is_pop : true,
      key:'',
      text:'示例文字',
      list:[],
      img:'https://weiye.weipaiyuan.cn/img.jpg',
      video:'https://weiye.weipaiyuan.cn/img.jpg',
      qrcode:'https://static.clewm.net/cli/images/nc/qrcode-none-new@2x.png',
      dialogVisible: false,
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 750, // 默认生成截图框宽度
        autoCropHeight: 1000, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [3, 4], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      date:'',
      sort_list:[],
      ebook_list:[],
    }
  },
  mounted:async function() {
    try {
      this.get_sort_list();
      this.get_ebook_list();
      let query = this.$route.query;
      if (query.id){
        await this.get_one(query.id);
        if (this.post.uid){
          let res_list = await this.$_api.admin('get_for_list', {uid : this.post.uid});
          if (res_list.errcode == 0){
            this.list = res_list.list;
          }
        }
      }
      // this.user_search('');
    }catch (e) {
      console.log(e);
    }
  },
  methods:{
    get_sort_list:async function (){
      let res = await this.$_api.page('sort_list', {size:100,uid:this.user.uid});
      if(res.errcode == 0){
        this.sort_list = res.list;
      }
    },
    get_ebook_list:async function (){
      let rs = await this.$_api.ebook('list', {uid : this.user.uid,page_id:0});
      if (rs.errcode == 0){
        this.ebook_list = rs.list;
      }
    },
    user_search : async function (e){
      try{
        console.log(e);
        this.is_loading = true;
        let res = await this.$_api.admin('get_user_list', {keyword : e});
        this.is_loading = false;
        if (res.errcode == 0){
          this.list = res.list;
        }
      }catch (e){
        console.log(e);
        return false;
      }
    },
    insert:function (type){
      console.log(type);
      let data = [];
      if(type=='title'){
        data = {type:'title',title:'正文标题',class:'web_title'};
      }
      if(type=='text'){
        data = {type:'text',text:'正文内容',class:'web_text'};
      }
      if(type=='img'){
        data = {type:'img',url:this.img,class:'web_img',item:[]};
      }
      if(type=='video'){
        data = {type:'video',url:this.video,class:'web_video'};
      }
      if(type=='swiper'){
        data = {type:'swiper',data:[this.img,],class:'web_swiper'};
      }
      this.post.content.push(data);
    },
    submit:async function (){
      try {
        let that = this;
        this.$refs['post'].validate( async function  (check){
          if (check){
            if(that.post.look_type==2) {
              if(that.date){
                that.post['start_time'] = that.date[0];
                that.post['end_time'] = that.date[1];
              }else{
                that.$_showToast('请选择日期','error');
                return;
              }
            }
            let way = that.post['id'] ? 'edit' : 'add';
            that.post['create_id'] = that.user.uid;
            that.post['uid'] = that.user.uid;
            that.$_showLoading();
            let res = await that.$_api.page(way, that.post);
            that.$_hideLoading();
            that.$_showToast(res.errmsg,res.style);
            if(res.errcode == 0){
              that.post.qrcode = res.url;
              setTimeout(function (){
                // if(that.user.login_type=='company'){
                //   that.$router.push('company_page_list');
                // }else{
                //   that.$router.push('one_page');
                // }
                if(that.post['id']){
                  that.$router.push({path:'/one_page_detail',query:{id:res.data}});
                }else{
                  if(that.user.login_type=='company'){
                    that.$router.push('company_page_list');
                  }else{
                    that.$router.push('one_page');
                  }
                }
              },1500)
              // if(!that.post['id']){
              //   that.$router.push({path:'/one_page_detail',query:{id:res.data}});
              // }
            }
          }
        })
      }catch (e) {
        console.log(e);
      }
    },
    get_one:async function(id){
      try {
        let res = await this.$_api.page('get_one_for_post', {id : id});
        if (res.errcode == 0){
          console.log(res.post);
          this.post = res.post;
          this.date = res.date;
          // this.content = res.post.content;
        }
      }catch (e) {
        console.log(e);
      }
    },
    changeUpload:async function (e) {
      console.log(e);
      let file = e;
      const isLt5M = file.size / 1024  < 3000
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 3000KB!')
        return false
      }
      // let res = await this.$_api.upload(file,this.dir.join('/'));
      let res = window.URL.createObjectURL(file.raw);
      console.log(res);
      this.fileinfo = file;
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = res;
        this.dialogVisible = true;
      })
    },
    finish() {
      let that = this;
      this.$refs.cropper.getCropBlob(async function (data) {
        // var fileName = 'goods' + this.fileinfo.uid
        console.log(data);
        let res = await that.$_api.upload(data,that.dir.join('/'));
        that.post.cover = res.url;
        that.dialogVisible = false;
        // console.log(fileName);
        // 上传阿里云服务器
        // client().put(fileName, data).then(result => {
        //   this.dialogVisible = false
        //   this.picsList.push(result.url)
        // }).catch(err => {
        //   console.log(err)
        //   this.loading = false
        // })
      })
    }
  }
}
</script>

<style scoped>
.back{border-bottom: 1px solid #eee;color: #ccc;cursor: pointer;padding: 10px;}
.detail{margin: 20px;display: flex;}
.create{
  /*border: 1px solid #dcdfe6;*/
  box-shadow: 0 0 5px #dcdfe6;
  border-radius: 5px;
  padding: 20px 10px;
  color: #999;
  width: 350px;
}
.o-user { height: 34px; display: flex; overflow-x: hidden; }
.o-avatarurl { width: 34px; height: 34px; border-radius: 17px; overflow-x: hidden; background: transparent no-repeat center; background-size: cover; }
.o-nickname { flex: 1; padding-left: 10px; }

.cut{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: none;
}
.cropper-content .cropper {
  width: auto;
  height: 300px;
}
</style>